<template>
<div>
  <v-img eager gradient="to bottom, rgba(255, 255, 255, 0.6), rgba(255, 255, 255, .1)" style="min-height: 100vh; max-height: 100vh;" :src="require('@/assets/bg-white.jpeg')"></v-img>
  <v-layout align-center justify-center fill-height style="position: absolute; z-index: 1; top: 0; min-width: 100vw; max-width: 100vw;">
    <v-flex xs12 sm6 md4 xl3 class="px-2">
      <!-- <v-card class="elevation-7" style="background-color: rgba(0,0,0,0.65) !important;">
        <v-toolbar flat dark style="background-color: rgba(0,0,0,0.1) !important;">
          <v-layout align-center>
            <v-avatar size="42" style="opacity: 0.95;" class="ml-n2 mr-4"> <v-img src="@/assets/alias.png"/> </v-avatar>
            <a class="white--text" style="text-decoration: none;" href="https://alias.ac">Powered By Alias</a>
          </v-layout>
        </v-toolbar>
      </v-card> -->
      <v-card class="elevation-7 mt-n3" style="background-color: rgba(0,0,0,0.65) !important;">
        <v-toolbar flat dark style="background-color: rgba(0,0,0,0.1) !important;">
          <v-layout>
            <span>{{ currentTitle }}</span> 
            <!-- alias todo: add back link -->
            <!-- <v-spacer></v-spacer> <a href="https://alias.ac" target="_blank" class='white--text' style="text-decoration: none;">Powered by Alias</a> -->
          </v-layout>
        </v-toolbar>
        <v-card-text>
          <v-form ref="signup">
            <v-window v-model="step">
              <v-window-item :value="0" class="text-center">
                <!-- radio btns -->
                <v-radio-group dark dense v-model="plan" class="pl-4 pt-0 pb-2" :mandatory="false">
                  <v-radio label="Public Or Private Practice" :value="1"></v-radio>
                  <v-radio label="Billing Agency" :value="2"></v-radio>
                  <v-radio label="Non-Profit Practice" :value="0"></v-radio>
                  <v-radio label="Educational Institute" value="education"></v-radio>
                  <!-- <v-radio label="Other" value="other"></v-radio> -->
                </v-radio-group>
                <a href="/#pricing" target="_blank" class="white--text body-2" style="text-decoration: none; opacity: 0.7; border-bottom: 1px solid rgba(255,255,255, 0.5);">View Pricing Plans</a>
              </v-window-item>

              <!-- #1 -->
              <v-window-item :value="1">


                <div v-if="plan === 'education'" class="text-center body-1 white--text" style="opacity: 0.82;">
                  <p>Email us at our contact <a href="mailto:hello@getbillit.com" target="_blank">hello@getbillit.com</a> with the name of your institute/school board, location, and your proposition for the integration of Billit in your curriculum. We look forward to being an aid for learning.</p>
                  <p class="caption font-weight-light">Be sure to send the email with an address attached to your educational institute.</p>
                </div>

                <template v-else>
                  <v-text-field
                    outlined shaped dark
                    v-model="practiceName" @keyup.enter="next"
                    prepend-icon="mdi-account-outline" persistent-hint
                    :label="`${plan === 2 ? 'Agency' : 'Practice'} Name`" :hint="`What is the name of your ${plan === 2 ? 'billing agency' : 'practice'}?`"
                  ></v-text-field>
                  <v-text-field
                    dark outlined shaped class="mt-4" @keyup.enter="next"
                    v-model="url" prepend-icon="mdi-link-variant"
                    label="Website URL" :placeholder="`www.my${plan === 2 ? 'agency' : 'practice'}.com`"
                  ></v-text-field>
                </template>
              </v-window-item>

              <v-window-item :value="2">
                <!-- #2 -->
                <v-select
                  :items="[{text: `Single Client`, value: 'Single Location'}, {text: 'Multiple Clients', value: 'Multiple Locations'}]"
                  v-model="locationCount" dark :item-text="plan === 2 ? 'text' : 'value'" item-value="value"
                  prepend-icon="mdi-map-marker-outline"
                  :label="`Setup of ${plan === 2 ? 'Clients' : 'Practice Locations'}`" :menu-props="{ 'closeOnClick': false, 'dark': true, 'dense': true, 'closeOnContentClick': false, 'disableKeys': true, 'openOnClick': false, 'maxHeight': 304 }"
                  outlined shaped
                ></v-select>
                <!-- #3 -->
                <v-layout v-if="locationCount === 'Single Location'" wrap>
                  <v-flex xs6>
                    <v-select 
                      :items="$store.state.stateSelect"
                      v-model="state" dark prepend-icon="mdi-xd"
                      label="State" :menu-props="{ 'closeOnClick': false, 'dark': true, 'dense': true, 'closeOnContentClick': false, 'disableKeys': true, 'openOnClick': false, 'maxHeight': 304 }"
                      outlined dense shaped
                    ></v-select>
                  </v-flex>
                  <v-flex xs6>
                    <v-select
                      :items="$store.getters.citySelect(state)"
                      v-model="city" dark class="pl-3"
                      label="City" :menu-props="{ 'closeOnClick': false, 'dark': true, 'dense': true, 'closeOnContentClick': false, 'disableKeys': true, 'openOnClick': false, 'maxHeight': 304 }"
                      outlined dense shaped
                    ></v-select>
                  </v-flex>
                  <!-- <v-flex xs12>
                    <v-text-field @keyup.enter="next"
                      outlined shaped dark dense v-model="address"
                      prepend-icon="mdi-lol" label="Address"
                    ></v-text-field>
                  </v-flex> -->
                </v-layout>
                <p style="opacity: 0.65;" class="white--text caption text-center">In the Billit Dashboard, you can add as many {{ plan === 2 ? 'Clients' : 'Locations' }} as you need.</p>
              </v-window-item>

              <v-window-item :value="3">
                <v-text-field @keyup.enter="next"
                  dark outlined shaped class="mb-4 mt-2"
                  v-model="email" :placeholder="`admin@${plan === 2 ? 'agency' : 'practice'}.com`"
                  prepend-icon="mdi-email-outline" persistent-hint
                  label="Work Email" :hint="`Don’t use your personal email, use a work email from ${practiceName}. If you intend to share admin abilities on this Billit account with other individuals, use a standard company email.`"
                ></v-text-field>
                <v-text-field @keyup.enter="next"
                  :append-icon="showPassword ? 'mdi-eye-outline' : 'mdi-eye-off-outline'"
                  @click:append="showPassword = !showPassword"
                  :type="showPassword ? 'password' : 'text'"
                  dark outlined shaped
                  v-model="password" class="mb-4"
                  prepend-icon="mdi-shield-plus-outline"
                  label="Password" persistent-hint
                  hint="Don’t make this password unique to you personally if you intend to share admin abilities on this Billit account with other individuals, since every admin will use this same password to login."
                ></v-text-field>
                <!-- <v-text-field @keyup.enter="next"
                  :append-icon="showCode ? 'mdi-eye-outline' : 'mdi-eye-off-outline'"
                  @click:append="showCode = !showCode"
                  :type="showCode ? 'password' : 'text'"
                  dark outlined shaped
                  v-model="code" class="mb-4"
                  prepend-icon="mdi-lock-outline"
                  label="Global Access Code" persistent-hint
                  hint="This global access code should only be shared with administrative staff who are allowed to alter any & all account data on the Billit Dashboard. Codes of varying permissions can always be made in the Dashboard."
                ></v-text-field> -->
                <v-text-field @keyup.enter="next"
                  :append-icon="showBuildKey ? 'mdi-eye-outline' : 'mdi-eye-off-outline'"
                  @click:append="showBuildKey = !showBuildKey"
                  :type="showBuildKey ? 'password' : 'text'"
                  dark outlined shaped
                  v-model="buildKey" class="mb-4"
                  prepend-icon="mdi-lock-outline"
                  label="Build Encryption Key" persistent-hint
                  :hint="`This is the key for staff access to ${practiceName}'s Billit Build login and URL. You can set it to a custom value or leave it how it is. Can be viewed in your dashboard and changed at any time.`"
                ></v-text-field>
              </v-window-item>

              <v-window-item :value="4">
                <v-file-input
                  :label="`${plan === 2 ? 'Billing Agency' : 'Medical Practice'} Logo`" show-size counter accept="image/*" class="mb-5" prepend-icon=""
                  outlined shaped hint="This branding logo will be displayed in various parts of Billit."
                  clearable dark persistent-hint placeholder="Click To Upload" v-model="logo" :rules="[value => !value || value.size < 2000000 || 'Logo size must be less than 2 MB']"
                ></v-file-input>
                <v-combobox
                  v-model="fiveCustomURLs" outlined shaped
                  hide-selected :search-input.sync="fiveSearch"
                  hint="Up to 5 URLs. These will be at the starting page for your Billit Build and are editable at any time. Press enter after each URL." dark deletable-chips
                  label="Custom URLs" multiple
                  persistent-hint small-chips hide-no-data
                >
                  <template v-slot:selection="{ attrs, item, parent, selected }">
                    <v-chip
                      v-bind="attrs"
                      color="transparent" dark
                      :input-value="selected" label small
                    >
                      <span class="pr-2">
                        {{ item }}
                      </span>
                      <v-icon
                        small
                        @click="parent.selectItem(item)"
                      >mdi-close</v-icon>
                    </v-chip>
                  </template>
                </v-combobox>
                <v-layout column align-center class="mt-6">
                  <v-flex style="width: 100%;">
                    <p style="opacity: 0.65;" class="white--text caption text-center mb-1">Brand Color Hex Code.</p>
                    <v-color-picker v-model="color" width="100%"
                      class="mb-3" dot-size="20" flat mode="hexa" hide-mode-switch
                      dark hide-canvas style="background-color: rgba(0,0,0,0); border: 1px solid rgba(255, 255, 255, .23); border-radius: 21px 21px 0 0;"
                    ></v-color-picker>
                  </v-flex>
                </v-layout>
              </v-window-item>

              <v-window-item :value="5" class="px-1 pb-4">
                <v-text-field
                  dark outlined class="mt-4" prepend-icon="mdi-account-outline" persistent-hint
                  :hint="`${plan === 2 ? 'Your clients are the current medical practices that you conduct billing tasks, audits, and collection for.' : 'Your providers are the primary care employees at your practice (doctor, physician, clinician)'}`"
                  shaped type="number" v-model.number="providerCount" @keyup.enter="next"
                  :label="`Number of ${plan === 2 ? 'Clients' : 'Providers'}`" :rules="[() => (!!providerCount && providerCount > 0) || `At least 1 ${plan === 2 ? 'client' : 'provider'} to use Billit.`]"
                ></v-text-field> 
                <v-text-field
                  dark outlined class="mt-4" prepend-icon="mdi-account-outline" persistent-hint  :rules="[() => (midLevelCount >= 0) || 'Invalid staffing count.']"
                  shaped type="number" v-model.number="midLevelCount" @keyup.enter="next" v-if="plan < 2"
                  label="Number of Mid-Level Staff" hint="Your mid-level staff are staff that perform at a mid-level at your practice (physician assistant, registered nurse)"
                ></v-text-field>
                <v-checkbox dark hide-details v-model="confirmedProviderCountAccuracy" @keyup.enter="next">
                  <template v-slot:label>
                    <span>
                      <!-- hioz todo: href="https://alias.ac/legal/billit/terms" -->
                      I have confirmed that this information is accurate for the {{ plan === 2 ? 'agency' : 'practice' }} I am creating a Billit account for, and that I understand and accept the consequences (as detailed in the “Fees and Billing” provision of Billit’s 
                      <router-link class="white--text" style="opacity: 0.75;" to="/terms" target="_blank">Terms of Service</router-link>) for giving false or outdated information regarding these numbers. These numbers can be updated at any time in the dashboard.
                    </span>
                  </template>
                </v-checkbox>
                <!-- <v-checkbox dark hide-details v-model="confirmedProviderCountAudit" label="I understand and accept my necessity to cooperate if Billit wishes to audit the number of providers my practice has employed. I also understand that failing to cooperate with any Billit-related audits can put my Billit subscription at risk for immediate termination, with no compensation entitled to me." @keyup.enter="next"></v-checkbox>
                <v-checkbox dark hide-details v-model="confirmedProviderCountChanges" label="Additonally, I understand and accept my commitment to keep the provider count as accurate as I can with changes over time, which I am able to change on my Account page (https://www.getbillit.com/account)." @keyup.enter="next"></v-checkbox> -->
              </v-window-item>

              <v-window-item :value="6" class="px-1 pb-4">
                <v-checkbox dark v-model="confirmedTermsAndPrivacy" @keyup.enter="next">
                  <template v-slot:label>
                    <span>
                      <!-- hioz todo: -->
                      Finally, I understand and agree to Billit’s <router-link class="white--text" style="opacity: 0.75;" to="/terms" target="_blank">Terms of Service</router-link> and <router-link class="white--text" style="opacity: 0.75;" to="/terms" target="_blank">Privacy Policy.</router-link>
                    </span>
                  </template>
                </v-checkbox>
                <span style="opacity: 0.7;" class="white--text caption ml-4">Almost there, just the billing setup!</span>
              </v-window-item>
              
              <v-window-item :value="7" class="px-1 pb-4">
                <span style="opacity: 0.7;" class="white--text caption">Please ensure that the Expiry, CVC, and Zip Code are all entered in the Card Number box. Zip input shows up after entering previous items.</span>
                <v-text-field
                  dark outlined class="mt-4"
                  v-model="cardholderName" shaped
                  label="Cardholder Name"
                ></v-text-field>
                <v-stripe-card
                  outlined shaped dark ref="stripeCard"
                  persistent-hint class="mb-1" hide-details
                  :api-key="publishableKey"
                ></v-stripe-card>
                <v-hover v-slot:default="{ hover }">
                  <p style="opacity: 0.65; width: 200px;" class="white--text caption my-4 pa-0 ml-4">{{ hover ? 'Powered by Stripe' : 'PCI Compliant Payments 🔐' }}</p>
                </v-hover>
                
                <span style="opacity: 0.7;" class="mt-6 ml-4 white--text caption">
                  <span v-if="plan === 0">$25</span>
                  <span v-else-if="plan === 1">$39</span> 
                  <span v-else-if="plan === 2">$45</span>  
                  base per month
                </span> <br>
                <template v-if="plan < 2">
                  <span style="opacity: 0.7;" class="mt-6 ml-4 white--text caption">{{ plan === 0 ? '$19' : '$29'}} per provider/mo</span> <br>
                  <span style="opacity: 0.7;" class="mt-6 ml-4 white--text caption">{{ plan === 0 ? '$10' : '$15'}} per mid-level/mo</span>
                </template>
                <template v-else>
                  <span style="opacity: 0.7;" class="mt-6 ml-4 white--text caption">$35 per client/month</span>
                </template>
                <!-- <v-divider class="my-6" style="opacity: 0.3"></v-divider> -->
                <v-text-field
                  dark class="mt-5 ml-4" style="max-width: 130px; opacity: 0.65;"
                  v-model="couponCode" dense prepend-icon="mdi-ticket-percent-outline"
                  label="Coupon Code" hide-details
                ></v-text-field>
              </v-window-item>
            </v-window>
          </v-form>
          <p v-if="feedback" class="red--text text-center text--lighten-2 px-1 ml-4 mt-2">{{ feedback }}</p>
          <p v-if="progress" class="white--text text-center px-1">{{ progress }}</p>
        </v-card-text>
        <div v-if="plan === 'education' && step === 1"></div>
        <v-card-actions v-else-if="!formDisabled" class="pt-0">
          <v-btn rounded color="white" text v-if="step > 0 && (step < 6 || feedback)" @click="step--; feedback = step > 5 ? feedback : '' " height="30" class="px-8" small>Back</v-btn>
          <v-spacer></v-spacer>
          <!-- if not final step, else -->
          <v-btn rounded color="white" @click="next" outlined v-if="step != 7" height="30" class="px-8" small>Next</v-btn>
          <v-btn rounded @click="signup" v-else :loading="loading" outlined height="30" small class="px-6 font-weight-bold" color="white">
            Signup
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
      <p v-if="step === 0" class="text-center mb-n5">Already have an account? <router-link class="black--text" to="/login">Login</router-link></p>
    </v-flex>
  </v-layout>
</div>
</template>

<script>
// var stripe = Stripe('pk_test_uk8hTMi7I0GmRCyBx4kIOuPf');
import VStripeCard from 'v-stripe-elements/lib/VStripeCard'

import { db, auth, authInterface, users, functions } from "@/firebase"

export default {
  components: { VStripeCard },
  data() {
    return {
      fiveSearch: null, loading: false, buildKey: '', url: '', fiveCustomURLs: [process.env.VUE_APP_DEPLOYED_URL_DASHBOARD],
      step: 0, state: null, city: null, address: '', color: '#55E6CC',
      zip: '', locationCount: null, logo: null, providerCount: 0, midLevelCount: 0,
      practiceName: '', cardholderName: '', confirmedTermsAndPrivacy: false,
      feedback: null, confirmedProviderCountAccuracy: false,  progress: '',
      accountType: null, confirmedProviderCountAudit: false, couponCode: '',
      email: "", confirmedProviderCountChanges: false, showBuildKey: false,
      password: "", formDisabled: false, showPassword: true, plan: 1,
    }
  },
  watch: {
    fiveCustomURLs(val) {
      if (val.length > 5) {
        this.$nextTick(() => this.fiveCustomURLs.pop())
      }
    },
    step(next, previous) {
      // skip over unnecesarry steps based on next and plan type
      // if (next === 2 && this.plan === 2) {
      //   if (previous === 1) {
      //     this.locationCount = 'Mulitple Locations'
      //     this.step++
      //   } else {
      //     this.step--
      //   }
      // } 
    }
  },
  computed: {
    currentTitle() {
      switch (this.step) {
        case 0: return 'Type of organization you\'re creating a Billit account for:'
        case 1: return this.plan === 'education' ? 'Get in touch!' : '1. Account Details'
        case 2: return '2. Where You Operate'
        case 3: return '3. Account & Security'
        case 4: return '4. Customization!'
        case 5: return '5. Employee Details'
        case 6: return '6. Terms & Conditions'
        case 7: return '7. Payment Method'
      }
    },
    publishableKey() {
      return process.env.VUE_APP_STRIPE_API_KEY
    }
  },
  created() {
    this.buildKey = [...crypto.getRandomValues(new Uint8Array(16))]
    .map((x,i)=>(i=x/255*61|0,String.fromCharCode(i+(i>9?i>35?61:55:48)))).join``;

    // console.log(this.$route.query.plan)
    if (this.$route.query.plan) {
      this.plan = ['0','1','2'].includes(this.$route.query.plan) ? parseInt(this.$route.query.plan) : this.$route.query.plan
    }
    if (this.$route.query.coupon) {
      this.couponCode = this.$route.query.coupon
    }
  },
  methods: {
    next() {
      let empty
      if (this.step === 1 && (!this.practiceName || !this.url)) empty = true
      if (this.step === 2) { 
        if (!this.locationCount) {
          empty = true  
        } else if (this.locationCount === 'Single Location') {
          if (!this.state || !this.city) empty = true
        }
      }
      if (this.step === 3 && (!this.email || !this.password || !this.buildKey)) empty = true
      if (this.step === 5 && (
        this.providerCount < 1 ||
        this.midLevelCount < 0 ||
        !this.confirmedProviderCountAccuracy
      )) empty = true
      if (this.step === 6 && (!this.confirmedTermsAndPrivacy)) empty = true

      if (empty) return this.feedback = 'Please fill out all information.' 
      this.step++ 
      this.feedback = ''
    },
    login() {
        auth.signInWithEmailAndPassword(this.email, this.password).then(data => {
          // dispatch fetch profile, currentUser in store
          this.progress = 'Almost there! Verifying credentials...'
          setTimeout(() => {
            this.$store.commit('setUser', auth.currentUser)
            if (this.$store.state.loggedIn) {
              this.$store.dispatch("bindLocations", db.collection('locations').where('userId', '==', this.$store.state.user.uid))
              this.$store.dispatch("bindPracticeData", db.collection('practiceData').doc(this.$store.state.user.uid))
              .then(() => {
                this.loading = false
                location.href = '/#tutorial'
                // this.$router.push('/account#successfulSignup')
              })
              .catch(err => {
                this.loading = false
                this.feedback = err.message
              })
            }
          }, 3000)
        })
        .catch(err => {
          this.loading = false
          this.feedback = err.message
        })
    },
    signup() {
      if (
        this.practiceName && this.url &&
        this.locationCount && [0, 1, 2].includes(this.plan) &&
        this.email && this.password && this.buildKey &&
        //this.logo &&
        this.providerCount && this.confirmedProviderCountAccuracy && 
        this.cardholderName && this.confirmedTermsAndPrivacy &&
        this.$refs.stripeCard.card && this.$refs.stripeCard.okToSubmit && this.$refs.stripeCard.stripe
      ) {
        this.loading = true
        this.feedback = ''
        this.$refs.stripeCard.errorBucket = []

        if (this.logo) {
          this.$toBase64(this.logo)
          .then(result => {
            this.logo = result
          })
          .catch(e => console.error(e))
        }

        this.$refs.stripeCard.stripe.createPaymentMethod({
          type: 'card', 
          card: this.$refs.stripeCard.card,
          billing_details: {
            email: this.email, 
            name: this.practiceName,
          },
        })
        .then(result => {
          const credentials = authInterface.EmailAuthProvider.credential(this.email, this.password).toJSON()
          let f = functions.httpsCallable('signup')
          f({ 
            completeSignupAfterConfirm: false, plan: this.plan,
            // 1
            displayName: this.practiceName,
            websiteURL: this.url,
            // 2
            initialLocationCount: this.locationCount,
            state: this.state, city: this.city, // address: this.address,
            // 3
            email: this.email,
            password: this.password,
            buildKey: this.buildKey,
            credentials,
            // code: this.code,
            // 4
            brandLogo: this.logo,
            billitBuildStartingURLs: this.fiveCustomURLs,
            brandColor: this.color,
            //5 
            providerCount: this.providerCount, midLevelCount: this.midLevelCount,
            confirmedProviderCountAccuracy: this.confirmedProviderCountAccuracy,
            confirmedProviderCountAudit: this.confirmedProviderCountAudit,
            confirmedProviderCountChanges: this.confirmedProviderCountChanges,
            // 6
            confirmedTermsAndPrivacy: this.confirmedTermsAndPrivacy,
            // 7
            cardholderName: this.cardholderName, couponCode: this.couponCode,
            createPaymentMethodResult: result,
          })
          .then(res => {
            if (res.data && res.data.status  === "requires_action") {
              this.$refs.stripeCard.stripe.confirmCardPayment(res.data.client_secret)
                .then(confirmCardResult => {
                  if (confirmCardResult.error) {
                    // The card was declined (i.e. insufficient funds, card has expired, etc)
                    this.feedback = confirmCardResult.error.message
                    this.formDisabled = true
                  } else {
                    // call it again
                    let fAfter = functions.httpsCallable('completeSignup')
                    fAfter({ 
                      user: res.data.user, customer: res.data.customer, latestInvoice: res.data.latest_invoice, subscriptionId: res.data.subscriptionId, plan: this.plan,
                      // 1
                      websiteURL: this.url,
                      // 2
                      initialLocationCount: this.locationCount,
                      state: this.state, city: this.city, // address: this.address,
                      // 3
                      buildKey: this.buildKey,
                      // code: this.code,
                      // 4
                      billitBuildStartingURLs: this.fiveCustomURLs,
                      brandColor: this.color, brandLogo: this.logo,
                      //5 
                      providerCount: this.providerCount, midLevelCount: this.midLevelCount,
                      confirmedProviderCountAccuracy: this.confirmedProviderCountAccuracy,
                      confirmedProviderCountAudit: this.confirmedProviderCountAudit,
                      confirmedProviderCountChanges: this.confirmedProviderCountChanges,
                      // 6
                      confirmedTermsAndPrivacy: this.confirmedTermsAndPrivacy,
                      // 7
                      cardholderName: this.cardholderName, couponCode: this.couponCode
                    })
                    .then(() => {
                      this.login()
                    })
                    .catch(error =>  {
                      this.feedback = error.message
                      this.formDisabled = true
                    })
                  }
                })
                .catch(error => {
                  this.feedback = error.message
                  this.formDisabled = true
                })
            } else {
              this.login()
            }
          })
          .catch(error => {
            this.feedback = error.message
            this.loading = false
          })
        })
        .catch(error => {
          this.feedback = error.message
        })
      } else {
        this.feedback = "Please fill in all fields"
      }
    }
  }
}
</script>